import React, {PropsWithChildren, useState} from "react";
import "./CollapsabelPanel.css";

interface Props {
  /**
   * The CSS class(es)
   */
  className?: string;

  /**
   * The text in the header
   */
  header: string;

  /**
   * The CSS class for the icon. For example "lcd-icon-layer"
   */
  headerIcon: string;

  /**
   * The initial collapsed state of this component
   */
  isCollapsed? : boolean;
}

export const CollapsablePanel = ({
                                   className,
                                   children,
                                   header,
                                   headerIcon,
                                   isCollapsed
                                 }: PropsWithChildren<Props>) => {

  const [collapsed, setCollapsed] = useState(isCollapsed ? isCollapsed : false);

  const toggleCollapsed = () => {
    setCollapsed(() => !collapsed);
  }

  const collapsedClass = collapsed ? "collapsed" : "open";

  return (
      <div className={`collapsable-panel ${className} ${collapsedClass}`}>
        <div className="collapsable-panel-header" onClick={toggleCollapsed}>
          <span className={`lcd-icon ${headerIcon}`}/>
          <span className="collapsable-panel-title">{header}</span>
          <div className="collapsable-panel-collapse-button">
            <span className="lcd-icon lcd-icon-caret-down"/>
          </div>
        </div>
        <div className="collapsable-panel-body">
          {children}
        </div>
      </div>
  );
}